module.exports = __webpack_public_path__ + "assets/account.4e643071.svg";